module.exports = __webpack_public_path__ + "media/images/subject_img/HUMAN SCIENCES-ANTHROPOLOGY-f3e36024eefca49abde621c76f8a8989.jpg";